export const search = {
	title: "Búsqueda de facturas fiscales",
	activeTab: "search",
	placeholder: "N° de la factura fiscal",
	search: "Buscar",
	export: "Exportar Excel",
	foreignDescription:
		"Permite buscar por el número del documento fiscal y filtrar por período.",
	sheet: {
		title: "Búsqueda de facturas fiscales",
		filename: "busqueda_de_facturas",
		columns: {
			xml: "XML",
			cancelledXml: "XML de Cancelación",
			jsonInvoice: "JSON Factura Fiscal",
			jsonCreditNote: "JSON Nota de Crédito",
			emitted: "Fecha de emisión",
			everestUploadTime: "Fecha de carga en Everest",
			isCanceled: "Cancelada",
		},
	},
	columns: {
		xml: {
			label: "XML",
			download: "Descargar XML de la factura fiscal",
			labelCancelledInvoice: "XML de la Factura Fiscal Cancelada",
			downloadCancelledInvoice: "Descargar XML de Cancelación",
		},
		json: {
			labelInvoice: "JSON del documento",
			labelCreditNote: "JSON de la Nota de Crédito",
			download: "Descargar JSON",
		},
		downloadPDF: "Descargar PDF",
		emitted: "Fecha de emisión",
		transactionDate: "Fecha de la transacción",
		everestUploadTime: "Fecha de carga en Everest",
		isCanceled: "Cancelada",
		type: "Tipo",
	},
};
